import { render, staticRenderFns } from "./CandidateModal.vue?vue&type=template&id=72d7a105"
import script from "./CandidateModal.vue?vue&type=script&lang=js"
export * from "./CandidateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72d7a105')) {
      api.createRecord('72d7a105', component.options)
    } else {
      api.reload('72d7a105', component.options)
    }
    module.hot.accept("./CandidateModal.vue?vue&type=template&id=72d7a105", function () {
      api.rerender('72d7a105', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/candidates/components/CandidateModal.vue"
export default component.exports